import { createContext, useContext, useState, useCallback } from "react";

const AdminContext = createContext(null);

export const AdminProvider = ({ children }) => {
  const [version, setVersion] = useState(0);
  const [clientOpen, setClientOpen] = useState(false);
  const [serviceOpen, setServiceOpen] = useState(false);
  const [servicePrefill, setServicePrefill] = useState(null);

  const refresh = useCallback(() => setVersion((v) => v + 1), []);
  const openNewClient = useCallback(() => setClientOpen(true), []);
  const openNewService = useCallback((clientId = null) => {
    setServicePrefill(clientId);
    setServiceOpen(true);
  }, []);

  return (
    <AdminContext.Provider
      value={{
        version, refresh,
        clientOpen, setClientOpen, openNewClient,
        serviceOpen, setServiceOpen, openNewService, servicePrefill,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);
